import { render, staticRenderFns } from "./useRegistry.vue?vue&type=template&id=b49032c4&scoped=true&"
import script from "./useRegistry.vue?vue&type=script&lang=js&"
export * from "./useRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49032c4",
  null
  
)

export default component.exports